import React, { useRef, useState } from 'react';
import DocumentPreviewModal from './DocumentPreviewModal';

/**
 * Read-only preview of a downloaded file (Blob) in the shared document viewer:
 * PDFs, Word files, images and text are shown in the app, other types offer a
 * download. Files are fetched through the backend and shown from memory - the
 * deployed Content-Security-Policy blocks S3 and blob: links in the viewer.
 *
 *   <FilePreviewModal file={blob} title="BGV Document" onClose={() => setPreview(null)} />
 */
const FilePreviewModal = ({ file, title, onClose }) => {
  const [scrollCompleted, setScrollCompleted] = useState(false);
  const [meta, setMeta] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const scrollRef = useRef(null);
  const ignore = () => {};

  return (
    <DocumentPreviewModal
      showDocumentPreviewModal={!!file}
      setShowDocumentPreviewModal={(open) => { if (!open) onClose(); }}
      documentPreviewTitle={title}
      setDocumentPreviewTitle={ignore}
      documentPreviewLoading={false}
      setDocumentPreviewLoading={ignore}
      documentPreviewUrl=""
      setDocumentPreviewUrl={ignore}
      documentPreviewFile={file}
      previewScrollContainerRef={scrollRef}
      handlePreviewScroll={ignore}
      isPreviewScrollCompleted={scrollCompleted}
      setIsPreviewScrollCompleted={setScrollCompleted}
      handleAgreeDocument={ignore}
      previewDocumentMeta={meta}
      setPreviewDocumentMeta={setMeta}
      previewPageCount={pageCount}
      setPreviewPageCount={setPageCount}
      previewCurrentPage={currentPage}
      setPreviewCurrentPage={setCurrentPage}
      user={null}
      showIAgree={false}
    />
  );
};

export default FilePreviewModal;
